<template>
  <vpreloader v-if="loading" width="2" size="64" />

  <error-view v-else-if="error" :error="error" @reload="fetch" />

  <component :is="way" v-else />
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import PROCESS_NAMES from '@/process/names';
  import DefaultScene from './default';
  import ErrorView from '@/process/_components/error-view';
  const SiburScene = () =>
    import(
      /* webpackChunkName: "sibur-test" */ '@/process/sibur-test/components/invites/creation/Scene.vue'
    );

  export default {
    name: 'InvitesCreationSceneWrapper',

    components: {
      ErrorView,
      'invites-creation-scene-default': DefaultScene,
      'invites-creation-scene-sibur': SiburScene
    },

    computed: {
      ...mapGetters('dictionary', ['loading', 'error', 'vacancies']),

      way() {
        let way = 'invites-creation-scene';

        if (this.$store.getters['invites/creation/hasProcess'](PROCESS_NAMES.SIBUR_TEST)) {
          return `${way}-sibur`;
        }

        return `${way}-default`;
      }
    },

    created() {
      if (this.$store.getters['invites/creation/hasProcess'](PROCESS_NAMES.SIBUR_TEST)) {
        this.fetch();
      }
    },

    methods: {
      ...mapActions('dictionary', ['fetch'])
    }
  };
</script>
